import React from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    title: 'NaaS Cloud Platform',
    path: '/naascloud',
    desc: 'Our cloud-native management platform provides a single pane of glass for all your network infrastructure. Zero-touch provisioning, real-time monitoring, AI-powered optimization, and automated operations across all locations.'
  },
  {
    title: 'Network Access Control',
    path: '/nac',
    desc: 'Enterprise-grade security with PacketFence and FreeRADIUS. 802.1X authentication, captive portals, device isolation, and integration with leading security tools to protect your network from edge to core.'
  },
  {
    title: 'Open Hardware',
    path: '/openhardware',
    desc: 'Cost-effective, vendor-neutral access points and PoE switches from leading manufacturers. WiFi 6 and 6E support, ceiling mount, wall plate, and outdoor options with zero vendor lock-in.'
  }
];

const Products = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Products</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Everything you need to deploy, manage, and secure enterprise-grade connectivity.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {products.map((product, i) => (
            <Link key={i} to={product.path} style={{
              padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', textDecoration: 'none', color: '#fff',
              display: 'block'
            }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#60a5fa' }}>{product.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{product.desc}</p>
              <span style={{ color: '#2563eb', marginTop: '16px', display: 'inline-block', fontWeight: '600' }}>
                Learn more &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
